module.exports = MaterialUI.Snackbar;